<div>
    <ngx-create-user-airline [id]="AirUserId"></ngx-create-user-airline>
</div>